module.exports = __webpack_public_path__ + "css/Ascot.bf716634.css";